import 'cross-fetch/polyfill'
import defaultsDeep from 'lodash/defaultsDeep'
import hash from './hash'

let defaults = {
  credentials: 'include',
  mode: 'cors'
}

export const setDefaults = (opts = {}) => {
  defaultsDeep(defaults, opts)
}

const _fetch = async (url, opts = {}) => {
  const o = defaultsDeep({}, defaults, opts)
  const originalUrl = url
  if(o.baseUrl) {
    url = o.baseUrl + url
    delete o.baseUrl
  }

  if(typeof window !== 'undefined' && window.__polystack_data__?.isStaticSite === true) {
    const h = await hash([originalUrl, o.method || 'GET', o.body].join(''))
    return fetch(`/_data/${h}.json`).then(j => j.json()).then(res => new Response(JSON.stringify(res.body), res))
  }

  return fetch(url, o)
}

export default _fetch
